module.exports = __webpack_public_path__ + "img/kr.9cdfad72.svg";